export default {
  icon: (smallIcon) => ({
    pointerEvents: 'none',
    position: 'absolute',
    transformOrigin: 'center',
    transition: '.4s',
    top: '50%',
    '&::before, &::after': {
      transformOrigin: 'center',
      content: "''",
      width: smallIcon ? '12px' : '16px',
      height: smallIcon ? '1px' : '2px',
      display: 'block',
      backgroundColor: 'kit.text.h',
      position: 'absolute',
      transform: 'translateX(-50%)',
    },
    '&::after': {
      transform: 'translateX(-50%) rotate(0deg)',
      transition: '.3s',
      opacity: 1,
    },
    '&::before': {
      transform: 'translateX(-50%) rotate(90deg)',
      transition: '.3s',
    },
  }),
  content: {
    maxWidth: 830,
  },
};
